import { AdDataTable, IntegrationPlatform } from "@models";

const data = {};

export const getMarketingData = () => {
  return Promise.resolve(data);
};
